import { ReactDOM } from 'ehs-react';
import * as React from 'react';
import { MenuUsers } from './MenuUser';

export function MenuUserList(): JSX.Element {
  // setup view for the menu user:
  const domNodes: HTMLCollection = document.getElementsByClassName(
    'LH_representativeRoleContainer'
  );
  const menuUserEntries = [];
  for (const domNode of domNodes) {
    menuUserEntries.push(ReactDOM.createPortal(<MenuUsers />, domNode));
  }

  return <>{menuUserEntries}</>;
}
